module.exports = __webpack_public_path__ + "img/media.9d1ec5eb.svg";